import React, { FC } from 'react'
import { DecryptedPatient } from '@icure/cardinal-sdk/model.mjs'
import { createSelector } from '@reduxjs/toolkit'
import { skipToken } from '@reduxjs/toolkit/query/react'
import { CardinalApiState } from '../../../../../core/services/auth.api'
import { useAppSelector } from '../../../../../core/hooks'
import { useFindContactsByHcPartyPatientQuery } from '../../../../../core/api/contactApi'
import { Consultation } from './Consultation'
import './index.less'
import { CommonPlaceholder } from '../../../../common/CommonPlaceholder'
import { useTranslation } from 'react-i18next'

interface ConsultationsProps {
  patient: DecryptedPatient
}

const reduxSelector = createSelector(
  (state: { cardinalApi: CardinalApiState }) => state.cardinalApi,
  (cardinalApi: CardinalApiState) => ({
    dataOwnerId: cardinalApi.dataOwnerId,
  }),
)

export const Consultations: FC<ConsultationsProps> = ({ patient }) => {
  const { t } = useTranslation()
  const { dataOwnerId } = useAppSelector(reduxSelector)

  const { data: listOfContactsWithDoctor, isLoading: isListOfContactsLoading } = useFindContactsByHcPartyPatientQuery(
    dataOwnerId ? { hcPartyId: dataOwnerId, patient } : skipToken,
  )
  const sortedContacts = [...(listOfContactsWithDoctor ?? [])]?.sort((a, b) => (b.openingDate ?? 0) - (a.openingDate ?? 0))

  return (
    <div className="consultations">
      <h2>{t('consultations.historyTitle')}</h2>
      <div className="consultations__collapceWrapper">
        {sortedContacts.map((contact, index) => (
          <Consultation key={index} contact={contact} patient={patient} />
        ))}
        {sortedContacts?.length === 0 && !isListOfContactsLoading && (
          <CommonPlaceholder borderless={true} title={t('consultations.noConsultationTitle')} content={t('consultations.noConsultationContent')} />
        )}
      </div>
    </div>
  )
}
